import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { setLocalStorage } from '../../Helper/helperFunctions';
import { setCurrentRoute } from '../../slices/sidebarSlice';
import { useDispatch } from 'react-redux';

const PrivateRoute = ({ requiredRoles }) => {
  const { user } = useAuth();
  const isAuthenticated = !!user;
  const dispatch = useDispatch();

  if(!isAuthenticated){
    dispatch(setCurrentRoute("login"));
    return <Navigate to="/login" />
  }
  if (requiredRoles && !requiredRoles.includes(user?.role)){
    dispatch(setCurrentRoute("home"));
    return <Navigate to="/" />
  }

  return <Outlet />
};

export default PrivateRoute;
